import { BulkActionsActionsLayout, BulkActionsLayout, BulkActionsOptionsLayout } from './bulk-actions.style';

export interface BulkActionsComponentProps extends React.PropsWithChildren {
    options?: React.ReactNode;
}

export const BulkActionsComponent: React.FC<BulkActionsComponentProps> = (props) => {
    const { children, options } = props;

    return (
        <BulkActionsLayout>
            <BulkActionsOptionsLayout>{options}</BulkActionsOptionsLayout>
            <BulkActionsActionsLayout>{children}</BulkActionsActionsLayout>
        </BulkActionsLayout>
    );
};
